import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import NotistackProvider from 'common/components/NotistackProvider'
import { th } from 'date-fns/locale'
import { lazy, Suspense } from 'react'
import { useSearchParams } from 'react-router-dom'
import { RecoilRoot } from 'recoil'
import WebviewRouter from 'routes/webview'
import ThemeConfig from 'theme'
import GlobalStyles from 'theme/globalStyles'

// routes
import { LocalizationProvider } from '@mui/x-date-pickers'
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns'

import { ProgressBarStyle } from 'components/LoadingScreen'
import ScrollToTop from 'components/ScrollToTop'
import ThemeLocalization from 'components/ThemeLocalization'
import ThemePrimaryColor from 'components/ThemePrimaryColor'

const Router = lazy(() => import('routes'))
const BaseOptionChartStyleLazy = lazy(() =>
  import('common/components/charts/BaseOptionChart').then((m) => ({
    default: m.BaseOptionChartStyle,
  }))
)

export const queryClient = new QueryClient()

export default function App() {
  const [searchParams] = useSearchParams()
  const isMobile = searchParams.get('isMobile') == 'true'

  if (isMobile) {
    return (
      <ThemeConfig>
        <ThemePrimaryColor>
          <ThemeLocalization>
            <QueryClientProvider client={queryClient}>
              <RecoilRoot>
                <NotistackProvider>
                  <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={th}>
                    <GlobalStyles />
                    <WebviewRouter />
                  </LocalizationProvider>
                </NotistackProvider>
              </RecoilRoot>
            </QueryClientProvider>
          </ThemeLocalization>
        </ThemePrimaryColor>
      </ThemeConfig>
    )
  }

  return (
    <ThemeConfig>
      <ThemePrimaryColor>
        <ThemeLocalization>
          <QueryClientProvider client={queryClient}>
            <RecoilRoot>
              <NotistackProvider>
                <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={th}>
                  <GlobalStyles />
                  <ProgressBarStyle />
                  <Suspense fallback={<div />}>
                    <BaseOptionChartStyleLazy />
                  </Suspense>
                  <ScrollToTop />
                  <Suspense fallback={<div />}>
                    <Router />
                  </Suspense>
                </LocalizationProvider>
              </NotistackProvider>
            </RecoilRoot>
          </QueryClientProvider>
        </ThemeLocalization>
      </ThemePrimaryColor>
    </ThemeConfig>
  )
}
